import React, { useEffect } from 'react';
import { eventsEmit } from '../services/appboxService';
import closeDialogIcon from '../assets/images/trains/kinds/ic_close_dialog.svg';
import imgLegendTrainPosition from '../assets/images/trains/kinds/img_legend_train_position.svg';
import icLegendRapid from '../assets/images/trains/kinds/ic_legend_rapid.svg';
import icLegendCommuterRapid from '../assets/images/trains/kinds/ic_legend_com_r.svg';
import icLegendSectionRapid from '../assets/images/trains/kinds/ic_legend_semi_r.svg';
import icLegendLocal from '../assets/images/trains/kinds/ic_legend_local.svg';
import icLegendTx1000 from '../assets/images/trains/kinds/ic_legend_tx1000.svg';
import icLegendTx2000 from '../assets/images/trains/kinds/ic_legend_tx2000.svg';
import icLegendTx2000Zoubi from '../assets/images/trains/kinds/ic_legend_tx2000_zoubi.svg';
import icLegendTx3000 from '../assets/images/trains/kinds/ic_legend_tx3000.svg';

const Kinds = () => {
  useEffect(() => {
    import('../assets/stylesheets/trains/kinds.css')
      .then(() => {})
      .catch(err => console.error("CSSの読み込みエラー", err));

    eventsEmit('guide.screen', {});
  }, []);

  return (
    <div>
      <main className="main-container">
        <div className="modal">
          <div className="modal-window">
            <div className="modal-header">
              <h2 className="kinds-title">ガイド</h2>
              <div className="modal-close">
                <a
                  href="/lines/mainline/trains"
                  className="close-button"
                  onClick={(event) => {
                    event.preventDefault();
                    eventsEmit('guide.close', {});
                    window.location.href = event.currentTarget.href;
                  }}
                >
                  <img
                    src={closeDialogIcon}
                    alt="Close Dialog"
                  />
                </a>
              </div>
            </div>
            <div className="main-content">
              <div className="modal-content">
                <img
                  src={imgLegendTrainPosition}
                  className="img-kinds-train"
                  alt="Train Position Legend"
                />
              </div>
              <div className="kinds-content">
                <p className="kinds-text">
                  遅延している場合、列車アイコンに遅延時分が表示されます。
                </p>
                <div className="content-type">
                  <div className="category-type">
                    <p className="category-type-header">種別</p>
                    <div className="category-type-icon">
                      <img
                        src={icLegendRapid}
                        alt="快速"
                      />
                      <span>快速</span>
                    </div>
                    <div className="category-type-icon">
                      <img
                        src={icLegendCommuterRapid}
                        alt="通勤快速"
                      />
                      <span>通勤快速</span>
                    </div>
                    <div className="category-type-icon">
                      <img
                        src={icLegendSectionRapid}
                        alt="区間快速"
                      />
                      <span>区間快速</span>
                    </div>
                    <div className="category-type-icon">
                      <img
                        src={icLegendLocal}
                        alt="普通"
                      />
                      <span>普通</span>
                    </div>
                  </div>
                  <div className="train-type">
                    <p className="train-type-header">車型</p>
                    <div className="train-type-icon">
                      <img
                        src={icLegendTx1000}
                        alt="1000系"
                      />
                      <span>1000系</span>
                    </div>
                    <div className="train-type-icon">
                      <img
                        src={icLegendTx2000}
                        alt="2000系"
                      />
                      <span>2000系</span>
                    </div>
                    <div className="train-type-icon">
                      <img
                        src={icLegendTx2000Zoubi}
                        alt="2000系（増備）"
                      />
                      <span>2000系（増備）</span>
                    </div>
                    <div className="train-type-icon">
                      <img
                        src={icLegendTx3000}
                        alt="3000系"
                      />
                      <span>3000系</span>
                    </div>
                  </div>
                </div>
                <div className="annotation-text">
                  <p>
                    実際の走行位置、行先、種別、車型、遅延時分とは異なる場合がございます。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Kinds;
